import { GetRecentTransactionFiles } from "../services/transactionService";
const requestTransactionFileType = "REQUEST_TRANSACTION_FILES";
const receiveTransactionFileType = "RECEIVE_TRANSACTION_FILES";
const initialState = { transactionFiles: [], loading: false };

export const actionCreators = {
  requestTransactionFiles: () => async (dispatch, getState) => {
    let { transactionFiles } = getState().transactions;
    if (transactionFiles && transactionFiles.length > 0) {
      return;
    }
    dispatch({ type: requestTransactionFileType });

    transactionFiles = await GetRecentTransactionFiles();

    dispatch({ type: receiveTransactionFileType, transactionFiles });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestTransactionFileType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveTransactionFileType) {
    const { transactionFiles } = action;
    return {
      ...state,
      transactionFiles,
      loading: false
    };
  }

  return state;
};
